import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { HelpCircle } from 'lucide-react';

const faqs = [
  {
    question: 'What types of care do you provide?',
    answer: 'We provide nursing, residential, dementia (nursing and residential), mental health nursing and bariatric nursing care. Our team works with each resident to create a personalised care plan that meets their individual needs.',
  },
  {
    question: 'Can we visit the home?',
    answer: 'Yes, we encourage visits. Please contact us to arrange a convenient time. We would be happy to show you around and answer any questions you may have.',
  },
  {
    question: 'Can residents personalise their rooms?',
    answer: 'Yes, residents are encouraged to bring personal items to make their room feel like home. We believe that familiar belongings help create a comfortable and reassuring environment.',
  },
  {
    question: 'How are care plans created?',
    answer: 'Care plans are tailored to each individual and regularly reviewed with input from families and healthcare professionals. We conduct comprehensive assessments before admission and continue to adapt care as needs change.',
  },
  {
    question: 'What are your visiting hours?',
    answer: 'We welcome visitors throughout the day and are flexible to accommodate families. We believe maintaining connections with loved ones is essential for our residents\' wellbeing.',
  },
  {
    question: 'How do you handle medical emergencies?',
    answer: 'Our nursing staff are trained to handle medical emergencies and we have protocols in place for rapid response. We work closely with local healthcare services and GPs to ensure residents receive prompt medical attention when needed.',
  },
];

const FAQSection = () => {
  return (
    <section
      id="faq"
      className="py-20 md:py-32 bg-slate-50"
      data-testid="faq-section"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#c9a227]/10 rounded-full text-[#c9a227] text-sm font-medium mb-6">
            <HelpCircle className="w-4 h-4" />
            FAQ
          </div>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1e3a5f] mb-6"
           
          >
            Frequently Asked Questions
          </h2>
          <p className="text-slate-600 text-lg">
            Find answers to common questions about our care services and facilities.
          </p>
        </div>

        {/* Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="bg-white rounded-2xl px-6 border border-slate-100 shadow-sm"
              data-testid={`faq-item-${index}`}
            >
              <AccordionTrigger className="text-left text-[#1e3a5f] font-semibold py-6 hover:text-[#c9a227] transition-colors">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 pb-6 leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;
